/*********************** Custom JS for Boost AI Search & Discovery  ************************/
let windowWidth = 0; // Initialize the windowWidth variable to store the width.
const isMobile = () => {
    if (!windowWidth) {
        // We don't want to re-calculate the width every time because it causes a style recalculation every time.
        // So we store it
        windowWidth = window.innerWidth;
        // Calculate the width on resize
        window.addEventListener('resize', () => {
            windowWidth = window.innerWidth;
        });
    }
    return windowWidth <= 768;
};

function _getWindowLocation() {
    // Escape window.location.href
    var href = window.location.href;
    var escapedHref = href.replace(/%3C/g, '&lt;').replace(/%3E/g, '&gt;');
    // Rebuild window.location.href
    var rebuildHrefArr = [];
    for (var i = 0; i < escapedHref.length; i++) {
        rebuildHrefArr.push(escapedHref.charAt(i));
    }
    var rebuildHref = rebuildHrefArr.join('').split('&lt;').join('%3C').split('&gt;').join('%3E');
    // Rebuild window.location.search
    var rebuildSearch = "";
    var hrefWithoutHash = rebuildHref.replace(/#.*$/, '');
    if (hrefWithoutHash.split('?').length > 1) {
        rebuildSearch = hrefWithoutHash.split('?')[1];
        if (rebuildSearch.length > 0) {
            rebuildSearch = '?' + rebuildSearch;
        }
    }
    return {
        pathname: window.location.pathname,
        href: rebuildHref,
        search: rebuildSearch
    }
}

function _isSearchPage() {
    // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/search?xxx
    // Google cache URL
    if (_getWindowLocation().href.includes('webcache.googleusercontent.com')) {
        return _getWindowLocation().search.indexOf('search?') > -1;
        // Normal URL
    } else {
        return window.location.pathname.indexOf('/search') > -1;
    }
};

function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        let breadcumbUpdated, productCountUpdated = false;
        componentRegistry.useComponentPlugin('Breadcrumb', {
            name: 'Breadcrumb component',
            apply: () => ({
                afterRender(element) {
                    try {
                        const breadcrumbElement = element.getRootElm();
                        if (breadcrumbElement && !breadcumbUpdated && !_isSearchPage()) {
                            breadcumbUpdated = true;
                            const layoutContainerElement = document.querySelector('.boost-sd__filter-block');
                            if (layoutContainerElement) {
                                layoutContainerElement.insertBefore(breadcrumbElement, layoutContainerElement.firstChild); // Move to below product list
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin('ProductCount', {
            name: 'ProductCount component',
            apply: () => ({
                afterRender(element) {
                    try {
                        const productCountElement = element.getRootElm();
                        if (productCountElement && !productCountUpdated && !_isSearchPage()) {
                            productCountUpdated = true;
                            const toolbarContainerElement = document.querySelector('.boost-sd__toolbar-container');
                            if (toolbarContainerElement) {
                                toolbarContainerElement.insertBefore(productCountElement, toolbarContainerElement.firstChild); // Move to below product list
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductItem component',
            apply: () => ({
                afterRender(element) {
                    try {
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                        if (productItem) {
                            const tagFiltered = productData.tags.find(function(e) {
                                return e.toLowerCase().indexOf('__label:') !== -1;
                            })
                            if (tagFiltered) {
                                const tagValue = tagFiltered.replace('__label:', '');
                                const newTagHtml = '<div class="boost-sd__custom-tag-badge"><span>' + tagValue + '</span></div>';
                                const imageWrapper = productItem.querySelector('.boost-sd__product-image-row--top > .boost-sd__product-image-column--left');
                                if (imageWrapper && !productItem.querySelector('.boost-sd__custom-tag-badge')) {
                                    imageWrapper.insertAdjacentHTML('beforeend', newTagHtml);
                                }
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });
        /* Start-Boost-232173 */
        componentRegistry.useComponentPlugin('CollectionHeader', {
            name: 'CollectionHeader component',
            apply: () => ({
                afterRender(element) {
                    try {
                        const collectHeaderElement = element.getRootElm();
                        // console.log(collectHeaderElement)
                        if (boostSDCustomData) {
                            if (isMobile() && boostSDCustomData?.collection_banner_mobile.indexOf('/files/?') == -1) {
                                const mobileHtml = '<div class="boost-sd__custom-collection-banner-mobile">' +
                                    '<img src="' + boostSDCustomData?.collection_banner_mobile + '" alt="' + boostSDAppConfig.generalSettings.collection_handle + '" />' +
                                    '</div>';
                                if (!collectHeaderElement.querySelector('.boost-sd__custom-collection-banner-mobile')) {
                                    collectHeaderElement.insertAdjacentHTML('afterbegin', mobileHtml);
                                }
                            } else if (boostSDCustomData?.collection_banner_desktop.indexOf('/files/?') == -1) {
                                const desktopHtml = '<div class="boost-sd__custom-collection-banner-desktop">' +
                                    '<img src="' + boostSDCustomData?.collection_banner_desktop + '" alt="' + boostSDAppConfig.generalSettings.collection_handle + '" />' +
                                    '</div>';
                                if (!collectHeaderElement.querySelector('.boost-sd__custom-collection-banner-desktop')) {
                                    collectHeaderElement.insertAdjacentHTML('afterbegin', desktopHtml);
                                }
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                },
            }),
        });
        /* Start-Boost-232173 */
        /* Start-Boost-302309 */
        componentRegistry.useComponentPlugin('FilterOption', {
            name: 'FilterOption component',
            apply: () => ({
                props(props, element) {
                    try {
                        if (props?.option) {
                            if (props?.option?.valueType == 'specific') {
                                props.option.sortManualValues = false;
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                    }

                    return props;
                },
            }),
        });
        /* Start-Boost-302309 */
    }
]);
const customizeSwatch = {
    removeOOSProductSwatches: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'Customize swatches',
            enabled: true,
            apply: () => ({
                props: (props) => {
                    props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
                    return props;
                },
                afterRender(element) {
                    const swatchOptions = element?.getParams()?.props?.options;
                    const productData =
                        componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                        componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
                    if (swatchOptions?.length && productData) {
                        const productVariants = productData.variants || [];
                        swatchOptions.forEach((option) => {
                            const optionValue = option.value;
                            option.available = checkOptionStatus(productVariants, optionValue);
                            checkOptionStatus(productVariants, optionValue);
                            if (!option.available) {
                                const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
                                if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                                    swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
                                }
                            }
                        });
                    }
                },
            }),
        });
    },
};

function checkOptionStatus(variants, optionValue) {
    for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        if (variant.title.toLowerCase() == optionValue.toLowerCase() && variant.available) {
            return true;
        }
        const variantOptions = variant.title?.split(' / ') || [];
        if (variantOptions.some((option) => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
            return true;
        }
    }
    return false;
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customizeSwatch.removeOOSProductSwatches,
]);